<template>
  <div class="tooltip-wrapper">
    <i
      :id="`${name}-tooltip`"
      :class="{
        'icon-outline_info': !hover,
        'icon-fill_info': hover,
      }"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    ></i>

    <b-tooltip :target="`${name}-tooltip`" triggers="hover" placement="rightbottom">
      {{ tooltipText[name] }}
    </b-tooltip>
  </div>
</template>

<script>
import tooltipText from '../lib/constants/tooltip-text.js'

export default {
  props: {
    name: {
      type: String,
      default: 'start-point',
    },
  },
  data() {
    return {
      hover: false,
    }
  },
  computed: {
    tooltipText
  }
}
</script>

<style lang="scss" scoped>
.tooltip-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 16px;
  }
}
</style>
